export default __webpack_public_path__ + "static/media/ic_gmx_40.72a1053e.svg";